var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlideImageNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "white",
    stroke: "#D3D3D3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2681 12.639C15.2118 12.6622 15.1638 12.7017 15.13 12.7523C15.0962 12.8029 15.0781 12.8624 15.0781 12.9232L15.0781 19.0771C15.0781 19.1379 15.0962 19.1974 15.13 19.248C15.1638 19.2986 15.2118 19.3381 15.2681 19.3613C15.3243 19.3846 15.3862 19.3907 15.4459 19.3789C15.5055 19.367 15.5604 19.3377 15.6034 19.2946L18.6803 16.2177C18.7089 16.1891 18.7315 16.1552 18.747 16.1179C18.7625 16.0806 18.7704 16.0406 18.7704 16.0001C18.7704 15.9597 18.7625 15.9197 18.747 15.8824C18.7315 15.8451 18.7089 15.8112 18.6803 15.7826L15.6034 12.7057C15.5604 12.6626 15.5055 12.6333 15.4458 12.6214C15.3862 12.6096 15.3243 12.6157 15.2681 12.639Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlideImageNext);
export default __webpack_public_path__ + "static/media/slide-image-next.eb893186f90a28397137f9f7a8a91a70.svg";
export { ForwardRef as ReactComponent };